<template>
  <v-container grid-list-xl>
    {{ adminText('workflowsAll.promote_container_4483e75', 'PROMOTE CONTAINER') }}
  </v-container>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'



export default {
  mixins: [WorkflowDisplay],
  name: 'promote-container',
  data(){
    return {
    }
  },
}
</script>

<style>

</style>
